<template>
	<div style="padding:5px;background:var(--grey-2);margin-top:0px;">
		<div class="flexcenter">
			<b style="padding-left:0px;color:var(--grey-6);flex-grow: 1;">{{ this.label }}</b>
			<Circle v-if="this.gridlayout" fileName="w3_grid_white" size="25px" padding="20%" color="--grey-5"
				@click="this.gridlayout = !this.gridlayout" />
			<Circle v-if="!this.gridlayout" fileName="w3_bars_white" size="25px" padding="20%" color="--grey-5"
				@click="this.gridlayout = !this.gridlayout" />
		</div>

		<div style="max-height:150px;overflow:scroll;margin-top:10px;">

			<div v-if="this.gridlayout" class="flexcenter" style="flex-wrap:nowrap;justify-content: stretch;align-items: stretch;">
				<SearchManufactorCell v-for=" (manufactor, index) in this.manufactorList"
					:manufactorId="manufactor.manufactorId" :key="manufactor.manufactorId + '_' +  index"
					:productCount="this.prouductCountLabel(manufactor)" @searchManufactorSelected="((manufactor) => {
						this.$emit('searchManufactorSelected', manufactor) } )"
					style="width:21%;border: 0px solid red;min-height: 100px;min-width:100px;" />
			</div>

			<div v-if="!this.gridlayout" style="">
				<SearchManufactorRow v-for="(manufactor, index) in this.manufactorList" :manufactorId="manufactor.manufactorId"
					:key="manufactor.manufactorId + '_' + index" :productCount="this.prouductCountLabel(manufactor)"
					@searchManufactorSelected="((manufactor) => {
						this.$emit('searchManufactorSelected', manufactor)
					})" />
			</div>
		</div>
	</div>
</template>
<script>
import listHelper from '@/helper/list-helper';
import { STORE_GETTER } from '@/store/store';
import SearchManufactorRow from './SearchManufactorRow.vue';
import { routerMixin } from "@/mixins/routerMixin.js";
import { PRODUCT_STORE_GETTER } from '../../../store/product-store';
import SearchManufactorCell from './SearchManufactorCell.vue';


//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SearchManufactorView",
	components: { SearchManufactorRow, SearchManufactorCell },
	mixins: [routerMixin],
	data() {
		return {
			manufactor: null,
			gridlayout: true

		};
	},
	computed: {

		/*manufactorList(){

			if (this.baseModel && this.baseModel.manufactorList){

				if (this.searchProductConfig && this.searchProductConfig.searchPhrase && this.searchProductConfig.searchPhrase.length > 1){

					return listHelper.filterList(this.baseModel.manufactorList, this.searchProductConfig.searchPhrase);

				}else{

					return this.baseModel.manufactorList
				}
				
			}
			return null;
			
		},*/
		manufactorList() {

			const manufactorList = this.$store.getters[STORE_GETTER.MANUFACTOR_LIST];

			if (manufactorList) {

				if (this.searchProductConfig && this.searchProductConfig.searchPhrase && this.searchProductConfig.searchPhrase.length > 1) {

					return listHelper.filterList(manufactorList, this.searchProductConfig.searchPhrase);

				} else {

					return manufactorList
				}

			}
			return null;

		},
		searchProductConfig() {

			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		},

		baseModel(){
			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];
			return baseModel;
		},


		label() {

			if (!this.manufactorList || this.manufactorList?.length == 0) {
				return "Hittade inget varumärke"
			}

			if (this.isOnProductListPage()) {
				return "Filtrera resultat på"
			} else {
				return "Visa allt från"
			}
		},

		productCountList(){

			const productList = this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST];

			var productCountList = [];

			productList.filter(product => product !== null).forEach(product => {
				const manufactorId = product?.manufactorId;

				if (manufactorId){
					var currentCount = productCountList[product.manufactorId];
					if (currentCount){
						currentCount += 1;
					}else{
						currentCount = 1;
					}

					productCountList[product.manufactorId] = currentCount;
				}
				
			})



			return productCountList;
		}

	},
	watch: {
		manufactor: function (manufactor) {
			console.log("FP: watcher: ", manufactor);
		}
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });
		prouductCountLabel(manufactor) {



			const count = this.productCountList[manufactor.manufactorId];

			if (count && count > 0) {
				return count + ""
			}

			return "--";

		},

	},
	created() {

	}
};
</script>

<style scoped></style>